(function($, root, undefined) {
    $(function() {
      'use strict';
  
      console.log('enabled');
  
      var $window = $(window);
  
      // smooth scrolling
      $(document).on('click', '.skip', function(event) {
        event.preventDefault();
  
        $('html, body').animate({
          scrollTop: $($.attr(this, 'href')).offset().top - 100
        }, 800);
      });
  
  
      //menu
      var isActive = false;
      $('.menu-btn').on('click', function() {
        if (isActive) {
          $(this).removeClass('open');
          $('html, .mobile-overlay').removeClass('menu-open');
          $('#header_placeholder').hide();
        } else {
          $(this).addClass('open');
          $('html, .mobile-overlay').addClass('menu-open');
          $('#header_placeholder').show();
  
        }
        isActive = !isActive;
      });
  
      //validate forms 
      if ($('form').length) {
        $("form").each(function() {
          $(this).validate();
        })
      }
  
      //sticky header
      // function stickyHeader () {
      //     var $headerheight = $('#header').outerHeight(true);
      //     $('#header_placeholder').css('height', $headerheight);
      // }    
  
      //header icon
      function headerIcon() {
        var $windowheight = $(window).scrollTop();
        var $headerheight = $('#header').outerHeight(true);
        if ($windowheight > ($headerheight + 250)) {
          $('.icon').addClass('active');
          $('.logo').removeClass('active');
        } else {
          $('.logo').addClass('active');
          $('.icon').removeClass('active');
        }
      }
  
      //header mobile nav resize
      function mobileNavResize() {
        var headerHeight = $('#header').outerHeight();
        var $windowheight = $(window).scrollTop();
        var $windowwidth = $(window).width();
        if ($('.promo-bar').hasClass('show')) {
          var promoBarHeight = $('.promo-bar').outerHeight(true);
          $('.mobile-menu-container nav').css('top', headerHeight + promoBarHeight - 2);
          $('.mobile-menu-container .search-container').css('top', -(headerHeight + promoBarHeight));
  
        } else {
          $('.mobile-menu-container nav').css('top', headerHeight);
          $('.mobile-menu-container .search-container').css('top', -headerHeight);
        }
        $('#header_placeholder').css('height', headerHeight);
        $('.mobile-menu-container nav').css({
          'min-height': $windowheight - headerHeight,
          'width': $windowwidth
        });
        // $('.search-container').css('height', originalNavHeight - headerHeight);
      }
  
  
      //dropdown
      var $headerheight = $('#header').outerHeight(true);
      $('.dropdown').css('transform', "translateY(" + $headerheight + "px)")
      if ($('.dropdown-parent').length) {
  
        $('.dropdown-parent, .dropdown').mouseover(function() {
          $('.dropdown').addClass('visible');
          $(this).addClass('active');
        });
        $('.dropdown').mouseleave(function() {
          $('.dropdown').removeClass('visible');
          $('.dropdown-parent').removeClass('active')
        });
  
        $('#header ul li:not(.dropdown-parent)').mouseenter(function() {
          $('.dropdown').removeClass('visible');
          $('.dropdown-parent').removeClass('active');
        })
  
        $('#header .dropdown-parent').hover(function() {
          var $dropdown = $('.dropdown .wrapper')
          var $items = $(this).find('.dropdown-child').html()
          //empties the dropdown and replaces it with dropdown stuff
          $dropdown.empty();
          $dropdown.html($items);
          var resetCuratedName = $dropdown.find('.baton-turbo-font').first().children().text();
          var resetCuratedImage = $dropdown.find('.baton-turbo-font').first().data('image');
          $('.dropdown-featured .text').text(resetCuratedName);
          if ($dropdown.find('.baton-turbo-font').first().data('image')) {
            $('.dropdown-featured').css('background', 'url(' + resetCuratedImage + ')')
          }
          //dropdown featured image  
          $('.dropdown ul li').mouseenter(function() {
            if ($(this).find('a').length > 0) {
              var collectionText = $(this).find('a').text();
              $('.dropdown-featured .text').animate({opacity:0}, 100, 'linear',function(){
                  $(this).text(collectionText)
                      .animate({opacity:1}, 100, 'linear');  
              })
//               $('.dropdown-featured').text(collectionText);
              if ($(this).data('image')) {
                var collectionImage = $(this).data('image');
                $('.dropdown-featured').css('background', 'url(' + collectionImage + ')')
              }
            }
          })
        })
        
        $('.body-content').prepend('<div class="nav-images-preload"></div>')
        
        //preload nav images
        $('.dropdown-child ul').each(function(){
          	var navImageSrc = $(this).children('li').data('image');
          	$('.nav-images-preload').append('<img src="' + navImageSrc + '">')
        })
  
      }
  
  
      //search
      $('#header .search').on('click', function() {
        $('.search-container').slideDown(function() {
          var $headerheight = $('#header').outerHeight(true);
          $('.dropdown').css('transform', "translateY(" + $headerheight + "px)")
        });
      })
      $('#header .search-container .close').on('click', function() {
        $('.search-container').slideUp(function() {
          var $headerheight = $('#header').outerHeight(true);
          $('.dropdown').css('transform', "translateY(" + $headerheight + "px)")
          $('#header').removeClass('white-bg');
        });
      })
      $('.mobile-menu-container #search').on('click', function() {
        $('.mobile-menu-container .search-container').addClass('show');
      })
      $('.mobile-menu-container .search-close-btn').on('click', function() {
        $('.mobile-menu-container .search-container').removeClass('show');
      })
  
      // scroll top
      $(".scroll").click(function() {
        $("html,body").animate({
          scrollTop: $("body").offset().top
        }, "1500");
        return false
      })
  
      // popup 
      // var newsletterShow = sessionStorage.getItem('newsletterShow');
      // if ($('.newsletter-popup').length) {
      //     setTimeout(function(){
      //         if (newsletterShow == null) {
      //             sessionStorage.setItem('newsletterShow', 1);
      //             $('.newsletter-popup').addClass('show');
      //         }
      //     }, 4000);
      // }        
      // $('.newsletter-popup .close').click(function() {
      //     $('.newsletter-popup').removeClass('show');
      // });   
  
      //promo
      var promoShow = sessionStorage.getItem('promoShow');
      if ($('.promo-bar').length) {
        if (promoShow == null) {
          sessionStorage.setItem('promoShow', 1);
          $('.promo-bar').addClass('show');
        }
      }
      $('.promo-bar .close').click(function() {
        var $headerheight = $('#header').outerHeight(true);
        $('.promo-bar').removeClass('show');
        $('#header').css('top', 0);
        $('.mobile-menu-container nav').css('top', $headerheight - 2);
              $('.promo-bar').hide();
   
      });
  
      //cart slide out
      if ($('.cart').length) {
        $('.cart').on('click', function(e) {
          e.preventDefault();
          $('.cart-items').addClass('open');
          $('.cart-overlay').addClass('show');
          $('body').addClass('cart-open');
        })
        //close cart by clicking "close" within cart
        $('.close-cart').on('click', function() {
          $cartItems.removeClass('open');
          $cartOverlay.removeClass('show');
          $('body').removeClass('cart-open');
        })
        //gift message 
        $('.gift-message a').on('click', function() {
          $('.checkout textarea').slideToggle();
          $('.cart-items').css('padding-bottom', '300px');
        })
        //close cart by clicking outside
        var $cart = $('.cart');
        var $cartItems = $('.cart-items');
        var $cartOverlay = $('.cart-overlay');
        $($cartOverlay).on('click touchstart', function(e) {
          if (!$cart.is(e.target) && $cart.has(e.target).length === 0) {
            $cartItems.removeClass('open');
            $cartOverlay.removeClass('show');
            $('body').removeClass('cart-open');
          }
        });
      }
  
      //home sliders
      if ($('#home').length) {
        $('.press .slider').slick({
          dots: false,
          prevArrow: $('.prev'),
          nextArrow: $('.next'),
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          responsive: [{
            breakpoint: 600,
            settings: {
              dots: true,
              arrows: false
            }
          }]
        });
      }
  
      //shop views
      if ($('#shop').length) {
        $('.view').on('click', function() {
          $('.view').removeClass('active');
          $(this).addClass('active');
          if ($(this).hasClass('two')) {
            $('.product-grid-item').removeClass('one-third');
            $('.product-grid-item').addClass('one-half');
            $('.section.grid .wrapper > .flex').addClass('two');
          }
          if ($(this).hasClass('three')) {
            $('.product-grid-item').addClass('one-third');
            $('.product-grid-item').removeClass('one-half');
            $('.section.grid .wrapper > .flex').removeClass('two')
          }
        })
      }
  
      //product page images
      if ($('#product').length) {
        $('.main .featured').slick({
          fade: true,
          dots: true,
          customPaging: function(slider, i) {
            var thumb = $(slider.$slides[i]).data();
            return '<a>' + (i + 1) + '</a>';
          },
          responsive: [{
            breakpoint: 860,
            settings: {
              adaptiveHeight: true
            }
          }]          
        });
        $('.main .featured').slickLightbox({
          background: 'rgba(58, 58, 58, 0.65)',
          src: 'src',
          itemSelector: 'img'
        });
      }
  
      //embroidery
      if ($('#embroidery').length) {
        $('.section.options .slider').slick({
          dots: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          fade: true,
          speed: 500,
          prevArrow: $('.arrows .prev'),
          nextArrow: $('.arrows .next'),
          customPaging: function(slider, i) {
            var name = $(slider.$slides[i]).data('name');
            return '<a class="baton-turbo-font">' + name + '</a>';
          },
          responsive: [{
            breakpoint: 1099,
            settings: {
              customPaging: function(slider, i) {
                var name = $(slider.$slides[i]).data('name');
                return '<a>' + i + '</a>';
              }
            }
          }]
        })
        $('.section.custom .btn').on('click', function(e) {
          $('.section.inquire').slideDown('slow');
        })
        $('.section.inquire .close').on('click', function(e) {
          $('.section.inquire').slideUp('slow');
        })
  
      }
  
      //insta slider
      if ($('.insta').length) {
        $('.insta .slider').slick({
          slidesToShow: 4,
          slidesToScroll: 1,
          prevArrow: $('.left-arrow'),
          nextArrow: $('.right-arrow'),
          responsive: [{
            breakpoint: 860,
            settings: {
              slidesToShow: 2
            }
          }]
        })
      }
  
      //accordion
      if ($('.accordion').length) {
        $(".item > .title").on("click", function() {
          if ($(this).hasClass("active")) {
            $(this).removeClass("active");
            $(this).siblings(".content").slideUp(200);
            $(".item > .title i").removeClass("minus").addClass("plus");
          } else {
            $(".item > .title i").removeClass("minus").addClass("plus");
            $(this).find("i").removeClass("plus").addClass("minus");
            $(".item > .title").removeClass("active");
            $(this).addClass("active");
            $(".accordion .content").slideUp(200);
            $(this).siblings(".content").slideDown(200);
          }
        });
      }
  
      //blog post side by side images
      if ($('#post').length) {
        var $floatLeftEl = $('img[style*="float"]');
        $floatLeftEl.addClass('float');
      }
  
      //account input label slide 
      if ($('.section form').length) {
        $('input:not(.submit)').on('click focusin', function() {
          if ($(this).val() == '') {
            $(this).prev().addClass('slideUp');
          }
        });
        $('input:not(.submit)').each(function(){
          if($(this).val() != ''){
            $(this).prev().addClass('slideUp');
          }
        })
      }
  
  
      //detect IE 
      function GetIEVersion() {
        var sAgent = window.navigator.userAgent;
        var Idx = sAgent.indexOf("MSIE");
  
        // If IE, return version number.
        if (Idx > 0)
          return parseInt(sAgent.substring(Idx + 5, sAgent.indexOf(".", Idx)));
  
        // If IE 11 then look for Updated user agent string.
        else if (!!navigator.userAgent.match(/Trident\/7\./))
          return 11;
  
        else
          return 0; //It is not IE
      }
  
      if (GetIEVersion() > 0) {
        console.log("This is IE " + GetIEVersion());
  
        $('.flex .col:not(.cart-items .flex .col), .select').addClass('ie');
  
      }
  
      //mobile disable hover
      function hasTouch() {
        return 'ontouchstart' in document.documentElement ||
          navigator.maxTouchPoints > 0 ||
          navigator.msMaxTouchPoints > 0;
      }
  
      if (hasTouch()) { // remove all :hover stylesheets
        try { // prevent exception on browsers not supporting DOM styleSheets properly
          for (var si in document.styleSheets) {
            var styleSheet = document.styleSheets[si];
            if (!styleSheet.rules) continue;
  
            for (var ri = styleSheet.rules.length - 1; ri >= 0; ri--) {
              if (!styleSheet.rules[ri].selectorText) continue;
  
              if (styleSheet.rules[ri].selectorText.match(':hover')) {
                styleSheet.deleteRule(ri);
              }
            }
          }
        } catch (ex) {}
      }
  
  
  
      // scroll functions
      function scrollWindow() {
  
  
        headerIcon();
  
  
      }
  
  
      function resizeWindow() {
  
        var $window = $(window);
  
        $('html').removeClass('frozen');
  
        mobileNavResize();
  
        if ($('.promo-bar').length) {
          if ($('.promo-bar').hasClass('show')) {
            if ($window.width() < 1100) {
              var promoBarHeight = $('.promo-bar').outerHeight(true);
              $('#header').css('top', promoBarHeight);
            } else {
              $('#header').css('top', 0);
            }
          }
        }
  
        if ($('#embroidery').length) {
          setTimeout(function() {
            var sliderHeight = $('#embroidery .section.options .slick-list').outerHeight(true);
            var sliderImgHeight = $('#embroidery .section.options .three-fifths .image').outerHeight(true);
            var sliderDotsHeight = $('#embroidery .section.options .slick-dots').outerHeight(true);
            var sliderDotsPos = sliderHeight - sliderImgHeight;
            if ($window.width() > 1300) {
              $('#embroidery .section.options .two-fifths').css('height', sliderImgHeight);
              $('#embroidery .section.options .two-fifths .inner').css('padding-bottom', sliderDotsHeight);
              $('#embroidery .section.options .arrows').css('bottom', sliderDotsPos);
              $('#embroidery .section.options .slick-dots').css('bottom', sliderDotsPos);
            } else {
              $('#embroidery .section.options .two-fifths .inner').css('padding-bottom', sliderDotsHeight);
              $('#embroidery .section.options .arrows').css('bottom', 0);
              $('#embroidery .section.options .slick-dots').css('bottom', 0);
              $('#embroidery .section.options .two-fifths').css('height', sliderHeight);
            }
          }, 100);
        }
  
        if ($('#home').length) {
          $('.embroidery .slider').not('.slick-initialized').slick({
            dots: false,
            arrows: false,
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: true,
            autoplay: true,
            autoplaySpeed: 2000,
            responsive: [{
                breakpoint: 860,
                settings: {
                  slidesToShow: 2,
                }
              },
              {
                breakpoint: 600,
                settings: "unslick"
              }
            ]
          });
          $('.instagram .flex').not('.slick-initialized').slick({
            responsive: [{
                breakpoint: 99999,
                settings: "unslick"
              },
              {
                breakpoint: 600,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1,
                  infinite: true,
                  autoplay: true,
                  autoplaySpeed: 2000               
                }
              }
            ]
          });
        }
  
        if ($('#shop').length) {
          if ($window.width() < 860) {
            $('.product-grid-item').removeClass('one-third');
            $('.product-grid-item').addClass('one-half');
            $('.section.grid .wrapper > .flex').addClass('two');
          } else {
            $('.view').removeClass('active');
            $('.section.grid .wrapper > .flex').addClass('three').removeClass('two');            
            $('.view.three').addClass('active');
          }
        }
        
        if($window.width() > 600){
           //select menu
          if($('select.nice').length){
            $('.nice').niceSelect();
            $( '.nice li' ).wrapInner('<span></span>'); 
          }
        } else {
           //select menu
          if($('select.nice').length){          
            $('.nice').niceSelect('destroy');
          }
        }
  
  
      }
  
      resizeWindow();
  
      scrollWindow();
  
      $window.resize(resizeWindow);
  
      $window.scroll(scrollWindow)
  
  
  
    });
  })(jQuery, this);